export default (keyboardListeners) => {

  for (const key in keyboardListeners) {
    if (keyboardListeners.hasOwnProperty(key)) {
      document.removeEventListener(key, keyboardListeners[key])
    }
  }

  return null
}